import type { ModulePage } from './types'

export const clients: ModulePage = {
  slug: 'clients',
  name: 'Client Management',
  tagline: 'Every client, every detail, every interaction, in one place.',
  icon: 'users',
  colorClass: 'portal',
  pricingModules: ['clients_full'],
  featured: true,

  seo: {
    title: 'Client Management & CRM',
    description:
      'A purpose-built CRM for financial advisers, with full client records, portfolios, household relationships and a complete history of every interaction in one place.',
    keywords:
      'financial adviser CRM, client management software IFA, adviser client records, wealth management CRM',
  },

  hero: {
    eyebrow: 'Client Management',
    title: 'Your whole practice,',
    titleAccent: 'one client record',
    subtitle:
      'A CRM built for advice. Full client records, households, portfolios and a complete history of every meeting, document and decision, always at your fingertips.',
  },

  useCases: [
    {
      icon: 'users',
      title: 'Know every client instantly',
      body: 'Open a record and see the full picture: circumstances, holdings, history and what’s next.',
    },
    {
      icon: 'chart',
      title: 'Portfolios & investments',
      body: 'Track holdings and valuations alongside the advice, so the numbers and the narrative live together.',
    },
    {
      icon: 'document',
      title: 'One timeline of everything',
      body: 'Every meeting, note, report and document attached to the client, in one chronological view.',
    },
  ],

  benefits: [
    {
      icon: 'users',
      title: 'Full client management',
      body: 'Households, relationships and connected parties modelled the way real advice firms work.',
    },
    {
      icon: 'chart',
      title: 'Portfolios in context',
      body: 'Investments and valuations sit next to the advice history, not in a separate silo.',
    },
    {
      icon: 'bolt',
      title: 'Connected to everything',
      body: 'Meetings, reports, tasks and the portal all read and write to the same client record.',
    },
    {
      icon: 'shield',
      title: 'A single source of truth',
      body: 'No more hunting across systems. The client record is complete, current and defensible.',
    },
  ],

  stats: [
    { value: 'One', label: 'record per client' },
    { value: '360°', label: 'view of every relationship' },
    { value: 'Always', label: 'up to date' },
  ],

  testimonial: {
    quote:
      'Significant improvements in efficiency and client service capabilities since integrating WealthSpace. Implementation was simple with major improvements from day one.',
    author: 'Deane Anderson',
    role: 'Director',
    company: 'Highclere Wealth',
  },

  cta: {
    title: 'Bring your clients',
    titleAccent: 'together',
    subtitle: 'See your whole practice in one place. Set up your client records in minutes.',
    note: 'Included from the Professional plan. Start free.',
  },
}
